import React from "react";

const ArrowIcon = ({ isPositive = false }) => {
  return (
    <div className={`postcard_arrow_main_wrapper ${isPositive ?"":"negative_arrow_wrapper" }`}>
    <div className={`postcard_arrow-container ${isPositive ?"positive_arrow_container":"negative_arrow_container" }`}>
      <div
        className={`top-arrow ${
          isPositive ? "top_positive_arrow" : "top_negative_arrow"
        }`}
      >
        <div></div>
        <div></div>
      </div>
      <div
        className={`double-arrow ${
          isPositive ? "double_positive_arrow" : "double_negative_arrow"
        }`}
      >
        <div></div>
        <div></div>
        <div className="arrow-tip">
          <div></div>
          <div></div>
        </div>
      </div>

      <div
        className={`double-arrow ${
          isPositive ? "double_positive_arrow" : "double_negative_arrow"
        }`}
      >
        <div></div>
        <div></div>
        <div className="arrow-tip">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
    </div>
  );
};
export default ArrowIcon;
